import React, { PropsWithChildren } from "react";
import useClientOnlyMounted from "./useClientOnlyMounted";

const ClientOnly: React.FC<
  PropsWithChildren<{ fallback?: React.ReactNode }>
> = ({ children, fallback = null }) => {
  const mountedState = useClientOnlyMounted();

  if (!mountedState) return <>{fallback}</>;

  return <React.Fragment>{children}</React.Fragment>;
};

export default ClientOnly;
